export const PDF_CONTENT_TYPES = ['application/pdf'];

export const PREVIEWABLE_IMAGE_CONTENT_TYPES = ['image/jpeg', 'image/png'];

export const BINARY_CONTENT_TYPES = [
  ...PDF_CONTENT_TYPES,
  ...PREVIEWABLE_IMAGE_CONTENT_TYPES,
];

const hasMatchingContentType = (
  contentType: string | null,
  allowedContentTypes: ReadonlyArray<string>,
) => {
  return allowedContentTypes.some((allowedContentType) =>
    contentType?.startsWith(allowedContentType),
  );
};

export const isBinaryContentType = (contentType: string | null) => {
  return hasMatchingContentType(contentType, BINARY_CONTENT_TYPES);
};

export const isPdfContentType = (contentType: string | null) => {
  return hasMatchingContentType(contentType, PDF_CONTENT_TYPES);
};

export const isPreviewableImageContentType = (contentType: string | null) => {
  return hasMatchingContentType(contentType, PREVIEWABLE_IMAGE_CONTENT_TYPES);
};
